import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(
    private http: HttpClient
  ) { }

  public eventId = "";
  public action = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };
  GetAllEventDetails(){
    return this.http.get(environment.apiURL +`event/GetAllEventDetails?IsActive=true`);
  }
  GetAllEventDetailsByCreatedDate(date){
    return this.http.get(environment.apiURL + `event/GetAllEventDetails?IsActive=true&CreatedOn=`+date);
  }
  GetAllEventDetailsByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `event/GetAllEventDetails?IsActive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetEventDetailsById(eventId){
    return this.http.get(environment.apiURL + `event/GetAllEventDetails?_id=`+eventId);
  }
  GetTherapyArea(){
    return this.http.get(environment.apiURL + 'master/GetTheraphyArea');
  }
  GetClient(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }
  GetCountry(){
    return this.http.get(environment.apiURL + `master/GetData?Type=Country`);
  }
  AddEvent(data){
    return this.http.post(environment.apiURL + `event/AddEvent`, data);
  }

  GetUserEvent(data){
    return this.http.post(environment.apiURL + `event/GetUserEvent`, data);
  }

  UpdateEvent(data){
    return this.http.post(environment.apiURL + `event/UpdateEvent`, data);
  }
  DeleteEvent(data){
    return this.http.post(environment.apiURL + `event/DeleteEvent`, data);
  }

  UploadPresentors(formData) {
    return this.http.post(environment.apiURL + `event/UploadEventPresentors`, formData, this.options);
  }

  DeleteEventPresentorFile(data) {
    return this.http.post(environment.apiURL + `event/DeleteEventPresentorAttachment`, data);
  }

  DeleteEventPresentor(data) {
    return this.http.post(environment.apiURL + `event/DeleteEventPresentors`, data);
  }
}
